import React, { useEffect, useRef, useState } from 'react'
import { CollapsibleContainer } from 'components/common'
import ButtonPlus from '../../components/ButtonPlus'
import './styles.scss'
import { useDispatch, useSelector } from 'react-redux'
import { UserCard } from '../../components'
import inChatRedux from 'redux/inchat/actions'
import { lang } from 'utils/helpers'
import ModalChannelList from './ModalListChannel'
import { apiInchat } from 'api'

const ChannelsContainer = ({ openCard }) => {
  const { inchat:{ channel: { conversations } } } = useSelector(state => state)
  const dispatch = useDispatch()
  const [isOpenModalList, setIsOpenModalList] = useState(false)

  const [openCollapsable, setOpenCollapsable] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const isFirstRender = useRef(true)

  useEffect(() => {
    const modalContent = document.querySelector('#channelMessagesInChat')
    if(openCollapsable && modalContent){
      modalContent.addEventListener('scroll', handleScroll)
    }else{
      if(modalContent) modalContent.removeEventListener('scroll', handleScroll)
    }
    return () => {if(modalContent) modalContent.removeEventListener('scroll', handleScroll)}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openCollapsable])

  useEffect(() => {
    // No se ejecuta el efecto la primera vez
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    if(openCollapsable) {
      getConversationList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openCollapsable])

  const handleScroll = (event) => {
    const scrollTop = event.target.scrollTop
    const scrollHeight = event.target.scrollHeight
    const clientHeight = event.target.clientHeight
    if (scrollTop + clientHeight >= scrollHeight) {
      nextPage()
    }
  }

  const handleOpenModal = () => {
    setIsOpenModalList(state => !state)
  }

  const getConversationList = async (nextPage = false) => {
    setIsLoading(true)
    await dispatch(inChatRedux.getDirectConversationsList(nextPage, 'channel'))
    setIsLoading(false)
  }

  const nextPage = () => {
    getConversationList(true)
  }

  const handleCollapsible = () => setOpenCollapsable(state => !state)

  const navigateCard = (conversation) => {
    openCard(conversation._id)
  }

  const conversationAction = async (body) => {
    try {
      const resp = await apiInchat.actionConversation(body)
      return resp.data
    } catch (error) {
      throw new Error(error)
    }
  }

  return (
    <div className='inchat-menu__container inchat-channels-container'>
      <CollapsibleContainer
        isOpen={openCollapsable}
        toggle={handleCollapsible}
        height={250}
        isLoading={isLoading}
        title={lang('dashboard_channels')}
        id={'channelMessagesInChat'}
        className={'inchat-channels-container__space'}
        optionsComponent={
          <div className='inchat-menu__options-collapsible'>
            <ButtonPlus
              onClick={handleOpenModal}
              altText={lang('dashboard_channels')}
            />
          </div>
        }
      >
        <div className='inchat-channels-container__list-channel'>
          {conversations.map((conversation, index) => {
            return (
              <UserCard
                key={conversation._id + index}
                conversation={conversation}
                onClick={navigateCard}
                conversationAction={conversationAction}
                withModalInfo
              />
            )
          })}
        </div>
      </CollapsibleContainer>
      {/* modal de lista de canales */}
      <ModalChannelList
        isOpenModal={isOpenModalList}
        handleOpenModal={handleOpenModal}
        getConversationList={getConversationList}
        conversationAction={conversationAction}
      />
    </div>
  )
}

export default ChannelsContainer
